import React from 'react'
import {Carousel} from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"
//Avatar Imports
 import avatar1 from "../images/job-opportunities-svgrepo-com.svg"
 import avatar2 from "../images/march-svgrepo-com.svg"
 import avatar3 from "../images/job-opportunities-svgrepo-com.svg"
 import avatar4 from "../images/march-svgrepo-com.svg"

function TestimonialsCarousel() {
    return (
        <Carousel
        showArrows= {true}
        infiniteLoop={true}
        showThumbs={false}
        showStatus={false}
        autoPlay={true}
        interval={2500}>


        <>
            <img src={avatar3} alt="Rahlokwa Mante"/>
            <div className="myCarousel">
                <h5>Rahlokwa Mante - Senior Developer and Team Lead at eSoftwareSolutions</h5>
                <i><p>"I recommend Bohlale very highly for any position in the IT field that involves complexity and creativity with high quality requirments. He is exceptionally bright and hard-working"</p>
                <small>If you are in need of any further information concerning Bohlale's Development Skills,  contact me at <a href="tel:0738171434">0738171434</a> </small></i>
            </div>
        </> 

        <>
            <img src={avatar3} alt="Katlego Thage"/>
            <div className="myCarousel">
                <h5>Katlego Thage - Database Administrator at NSG</h5>
                <i><p>"Bohlale is a fast learner, a versitile developer, and continues to impress me with his Database Analysis and SQL Scripting skills."</p>
                <small>If you are in need of any further information concerning Bohlale's Database Administration/SQL-Scripting Skills,  contact me at <a href="tel:0814827325">0814827325</a> </small></i>
            </div>
        </> 
        
        <>
            <img src={avatar2} alt="Hendrick Mahlangu"/>
            <div className="myCarousel">
                <h5>Hendrick Mahlangu - Director of GCPS</h5>
                <i><p>"Bohlale shows a high level of competence and dedication that borders on obsession in regards to his work. I can attest for his professionalism and design ability."</p>
                <small>If you are in need of any further infromation concerning his Web Development abilities, contact me at <a href="mailto:hendrickmahlangu777@gmail.com">hendrickmahlangu777@gmail.com</a> </small></i>
            </div>
        </> 

        <>
            <img src={avatar1} alt="Shikari Kranthi"/>
            <div className="myCarousel">
                <h5>Shikari Kranthi - Programme Convenor at Eduvos</h5>
                <i><p>"Bohlale is attentive and timely. He has shown a high level of dedication to all his work and therefore I can attest to his conduct and character."</p>
                <small>If you are in need of any further information concerning Bohlale's general conduct,  contact me at <a href="mailto:Kranthi.shikari@pearson.com">Kranthi.shikari@pearson.com</a> </small></i>
            </div>
        </>     

        <>
            <img src={avatar4} alt="Sina Madikwane"/>
            <div className="myCarousel">
                <h5>Sina Madikwane - Head Realtor and Owner of Sebitse Properties</h5>
                <i><p>Bohlale is a pleasure to work with. My experience with him thus far is that he is on time, highly competent, and willing to go the extra mile to ensure quality results</p>
                <small>If you are in need of any further information concerning Bohlale's general conduct,  contact me at <a href="tel:0645261857">0645261857</a> </small></i>
            </div>
        </>
        </Carousel>
    )
}

export default TestimonialsCarousel
